export default ['C', 'D', 'E', 'F', 'G', 'A', 'B']
